// extracted by mini-css-extract-plugin
module.exports = {"logo":"topLogo_logo__YGPl8"};